import { DevicesAPI, IGetDeviceByNameParams } from "../../services/hcnApi";

export const getDeviceByNameUseCase = async (
  params: IGetDeviceByNameParams
) => {
  const response = await DevicesAPI.getDeviceByName(params);
  
  return response;
};
